module.exports = __webpack_public_path__ + "4f7bfca3e4110decb3996a4a2d014144.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/assets/modelo4.png
// module id = 2815
// module chunks = 1